export enum AlertStatus {
  INFO = 0,
  SUCCESS = 1,
  ERROR = 2,
  WARNING = 3
}
